import React, { useCallback, useEffect, useState } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AppHeader from '@components/app-header';
import Portal from '@src/pages/portal';
import AppFooter from '@components/app-footer';
import './app-layout.scss';
import { Input, Spin, Result, Button } from 'antd';
import UserMenu from '@components/user-menu';
import { useInfo, useUser } from '@src/services/login';
import { useFetchScreen } from '@src/services/session';
import ResetPasswordModal from '@src/components/reset-password-modal';
import ScreenModal from '@src/components/screen-modal';
var prefixCls = 'app-layout';
var AppLayout = function () {
    var _a;
    var Search = Input.Search;
    var path = useRouteMatch().path;
    var inputRef = React.useRef(null);
    var _b = React.useState(''), keyword = _b[0], setKeyword = _b[1];
    var _c = useInfo(), isFetching = _c.isFetching, isError = _c.isError, error = _c.error, refetch = _c.refetch;
    var handleSubmit = React.useCallback(function (value) {
        setKeyword(value);
    }, []);
    var user = useUser();
    var _d = useState(false), visible = _d[0], setVisible = _d[1];
    var _e = useState({ timer: 0, bg: '' }), screenValues = _e[0], setScreenValues = _e[1];
    var _f = useState(false), screenVisible = _f[0], setScreenVisible = _f[1];
    /** 查询 ad */
    var _g = useFetchScreen(), isScreenFetching = _g.isFetching, isScreenError = _g.isError, screenData = _g.data;
    var checkDefaultPwd = useCallback(function () {
        var _a;
        var needChange = ((_a = user === null || user === void 0 ? void 0 : user.extraMap) === null || _a === void 0 ? void 0 : _a.defaultPwd) === '1' ||
            "" + sessionStorage.getItem('pwdCheck') === '0';
        setVisible(needChange);
    }, [(_a = user === null || user === void 0 ? void 0 : user.extraMap) === null || _a === void 0 ? void 0 : _a.defaultPwd]);
    var handleCloseAD = useCallback(function () {
        setScreenVisible(false);
        checkDefaultPwd();
    }, [checkDefaultPwd]);
    /** 监听 ad 请求状态 */
    useEffect(function () {
        if (isScreenFetching === false && isScreenError !== true) {
            if (user === void 0 || user === null || screenData === void 0) {
                return void 0;
            }
            var systemTime = user.extraMap.systemTime;
            var nowTime = new Date().getTime();
            var compareTime = systemTime ? systemTime : nowTime;
            var showAD = screenData.showAD, startTime = screenData.startTime, endTime = screenData.endTime, showSeconds = screenData.showSeconds, adUrls = screenData.adUrls;
            var visible_1 = Number(compareTime) >= startTime &&
                Number(compareTime) <= endTime &&
                showAD === 1;
            if (visible_1) {
                setScreenVisible(visible_1);
                setScreenValues({ timer: showSeconds, bg: adUrls[0] });
            }
            else {
                var reset = "" + sessionStorage.getItem('reset');
                if (reset === '0') {
                    setVisible(false);
                }
                else {
                    checkDefaultPwd();
                }
            }
        }
    }, [isScreenFetching, isScreenError, screenData, user, checkDefaultPwd]);
    return isFetching === true ||
        error === 'Request failed with status code 401' ? (React.createElement("div", { className: "app-layout-loading" },
        React.createElement(Spin, { tip: "\u6570\u636E\u52A0\u8F7D\u4E2D..." }))) : isError ? (React.createElement("div", { className: "app-layout-loading" },
        React.createElement(Result, { status: "500", subTitle: "" + (error || '网络错误，请稍后'), extra: React.createElement(React.Fragment, null,
                React.createElement(Button, { onClick: function () { return refetch(); } }, "\u91CD\u8BD5")) }))) : (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: path },
            React.createElement("div", { className: prefixCls + "_body" },
                React.createElement(AppHeader, null,
                    React.createElement(Search, { ref: inputRef, onSearch: handleSubmit, className: prefixCls + "_search", allowClear: true }),
                    React.createElement(UserMenu, { className: prefixCls + "_avatar" })),
                React.createElement("div", { className: prefixCls + "_body_mark" }),
                React.createElement(Switch, null,
                    React.createElement(Route, { exact: true, path: path },
                        React.createElement(Portal, { keyword: keyword }))),
                React.createElement(AppFooter, { className: prefixCls + "_footer_content" }),
                React.createElement(ResetPasswordModal, { visible: visible, onOk: function () { return setVisible(false); }, onCancel: function () { return setVisible(false); } }),
                screenVisible && (React.createElement(ScreenModal, { values: screenValues, onVisibleChange: handleCloseAD }))))));
};
export default React.memo(AppLayout);
